import input from './input';
import button from './button';
import app from './app';
import categories from './categories';

const french = {
    title: 'MarketPrint',
    button: button,
    input: input,
    app: app,
    categories: categories,
};

export default french;
